<template>
  <el-dialog :title="title" :visible.sync="visible" width="552px" :append-to-body="true" center>
    <div class="fix-form">
      <el-radio-group v-model="groupId" class="check-group">
        <el-radio v-for="(item,index) of list" :key="index"  :label="item.id" :disabled="currentGroupId ===item.id" >{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="save" :loading="btnLoading" :disabled="currentGroupId == groupId">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { title } from 'process';


export default {
  name: "autoFixRepeat",
  data() {
    return {
      visible: false,
      title:'',
      list:[],
      groupId:'',
      currentGroupId:'',
      btnLoading:false
    }
  },

  methods: {
    show(item,groupList) {
      console.log('>>',item,groupList)
      this.visible = true
      this.title = '将[' + item.templateName + ']移动到...'
      this.currentGroupId = item.groupId
      this.groupId = item.groupId
      this.templateId = item.id
      this.list = groupList
    },
    save() {
      console.log('>>',this.groupId)
      this.btnLoading = true
      const postData = {
            id: this.templateId,
            groupId: this.groupId,
        }
        this.$api.workflowMoveGroup(postData).then((res) => {
            if (res.code == 0) {
               this.$emit('success')
               this.visible = false
            } else {
                this.$message.error(res.message)
            }
            this.btnLoading = false
        }).catch(err => {
            this.btnLoading = false
        })
      // this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog--center .el-dialog__body{
  padding: 10px 32px 20px;
}
.fix-form{
  .title-con{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .label-title{
    font-weight: bold;
    font-size: 14px;
    color: #2F3030;
    margin-bottom: 2px;
  }
  /deep/.check-group{
    margin-bottom: 20px;
  }
  /deep/.el-radio{
    display: block;
    line-height: 34px;
    .name-text{
      color: #606266;
    }
  }
}
</style>
